import IntegrationView from './IntegrationView';

export default IntegrationView;
